import { render } from "./MaintenanceOverlay.vue?vue&type=template&id=f12353ba&scoped=true"
import script from "./MaintenanceOverlay.vue?vue&type=script&lang=js"
export * from "./MaintenanceOverlay.vue?vue&type=script&lang=js"

import "./MaintenanceOverlay.vue?vue&type=style&index=0&id=f12353ba&scoped=true&lang=css"

import exportComponent from "F:\\قبل النهائي\\nawaf\\nawaf\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f12353ba"]])

export default __exports__